export default "__VITE_ASSET__nG5pwqW1__"